'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import { FaTimes, FaGem } from 'react-icons/fa'
import { useAuth } from '../contexts/AuthContext'
import { CARD_BACKGROUNDS } from '../constants/cardBackgrounds'

const DeclinedBanner = () => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(true)
  const { subscription, user } = useAuth()
  const router = useRouter()

  if (!isVisible) return null

  const isFree = subscription?.plan === 'Free'
  const href = isFree ? '/upgrade' : '/gems'
  const buttonText = isFree ? t('upgrade') : t('getGems')

  const clearCentroDecline = async () => {
    if (!user) return

    try {
      const idToken = await user.getIdToken()

      await fetch(
        `${process.env.NEXT_PUBLIC_PROMPTCHAN_CLOUD}/api/clear_centro_decline`,
        {
          method: 'POST',
          headers: {
            Authorization: idToken,
            'Content-Type': 'application/json',
          },
        },
      )
    } catch (err) {
      console.error('Failed to clear centro_decline:', err)
    }
  }

  const handleNavigate = async () => {
    await clearCentroDecline()
    router.push(href)
  }

  const handleClose = async () => {
    await clearCentroDecline()
    setIsVisible(false)
  }

  return (
    <div className="relative mx-auto mt-6 max-w-5xl px-4">
      <div className="relative overflow-hidden rounded-xl border border-[#2C2D30] bg-[var(--middle-bg-color)] p-6 text-white shadow-xl">
        <div
          className="absolute inset-0 opacity-90"
          style={{ backgroundImage: CARD_BACKGROUNDS.blue }}
        />

        <div className="relative z-10 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          {/* Image (top on mobile, right on desktop) */}
          <div className="order-1 flex justify-center md:order-2">
            <div className="h-40 w-32 overflow-hidden rounded-2xl border border-white/20 bg-black/30 md:h-56 md:w-44">
              <img
                src="/assets/redeem0.webp"
                alt="Redeem"
                className="h-full w-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-2 flex flex-col items-center gap-4 text-center md:order-1 md:items-start md:text-left">
            <h3 className="text-2xl font-bold">{t('nearlyThere')}</h3>

            <p className="max-w-2xl text-sm text-gray-200 md:text-base">
              {t('declinedCardIntro')}{' '}
              <span className="font-semibold">
                {t('declinedTryDifferentCard')}
              </span>{' '}
              {t('declinedOrTryOption')}
            </p>

            <button
              onClick={handleNavigate}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--main-bg-color)] px-10 py-4 text-lg font-semibold text-white transition-transform duration-200 hover:scale-[1.03]"
            >
              <FaGem />
              {buttonText}
            </button>
          </div>
        </div>

        <button
          onClick={handleClose}
          className="absolute right-3 top-3 text-gray-300 hover:text-white"
          aria-label={t('close')}
        >
          <FaTimes />
        </button>
      </div>
    </div>
  )
}

export default DeclinedBanner
